import script from "./AdministratorPortfolios.vue?vue&type=script&setup=true&lang=js"
export * from "./AdministratorPortfolios.vue?vue&type=script&setup=true&lang=js"

import "./AdministratorPortfolios.vue?vue&type=style&index=0&id=36bcc2d1&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36bcc2d1"]])

export default __exports__